import { type Money, signOfMoney } from '@taler/domain'

/** A contact's per-currency net balances narrowed to what it owes you - the only part forgive can write off. */
export function forgivableReceivables(balances: readonly Money[]): readonly Money[] {
  return balances.filter((balance) => signOfMoney(balance) > 0)
}
